import React from "react";

export default function History_AI() {
  return (
    <div>
      <h1>History_AI</h1>
      <p>This is the History_AI component.</p>
    </div>
  );
}
